import React from 'react';
import PropTypes from 'prop-types';
import { Button, Form, PanelGroup } from 'react-bootstrap';

import { PERSONAL_SUBSCRIPTIONS, CARDIO_SUBSCRIPTIONS, STRENGTH_SUBSCRIPTIONS, ASSET_SUBSCRIPTIONS } from './LicenseConstants';
import FieldGroupComponent from '../../core/FieldGroupComponent/FieldGroupComponent';
import CheckboxComponent from '../../core/CheckboxComponent/CheckboxComponent';
import PanelComponent from '../../core/PanelComponent/PanelComponent';
import TooltipComponent from '../../core/TooltipComponent/TooltipComponent';
import GridContainer from '../../../containers/GridContainer';
import LinkComponent from '../../core/LinkComponent/LinkComponent';

import './licenseForm.scss';
import AddFacilitiesContainer from '../../../containers/AddFacilitiesContainer';
import { LICENSE_ACTIONS } from '../../../constants/common';

const _ = require('lodash');

const subscriptions = [...PERSONAL_SUBSCRIPTIONS, ...CARDIO_SUBSCRIPTIONS, ...STRENGTH_SUBSCRIPTIONS, ...ASSET_SUBSCRIPTIONS];
const additional = [{name: 'assetApi'}, {name: 'forcedLogIn'}];

class LicenseSubscriptionFormComponent extends React.Component {
    constructor(props) {
        super(props);

        const subscriptionNames = {};
        subscriptions.forEach(({ alwaysEnable, name }) => {
            if (!alwaysEnable) {
                subscriptionNames[name] = false;
            }
        });

        const additionalNames = {};
        additional.forEach(({ name }) => {
            additionalNames[name] = false;
        });

        this.state = {
            ...subscriptionNames,
            ...additionalNames,
            activeKey: 0,
            activeKey2: 0,
            checkedFacilities: {},
            searchVal: '',
            show: false,
            filter: 'all',
            value: '',
            showForceTooltip: false,
        };

        this.GRID_PROPS = [
            {
                title: 'Facility ID',
                className: 'id',
                getter: (item) => <div className={'facility-id' + (item.status === 'Unauthorized' || item.status === 'Incorrect ID' ? ' error' : '')}>{item.id}</div>,
            },
            {
                title: 'Status',
                className: 'status',
                getter: (item) => <div className={'facility-status' + (item.status === 'Unauthorized' || item.status === 'Incorrect ID' ? ' error' : '')}><span className={item.status.toLowerCase().split(' ').join('-') + '-icon'} /><span>{item.status}</span></div>,
            },
            {
                title: 'Checkbox',
                className: 'checkbox',
                getter: (item) => <CheckboxComponent
                    name={`${item.id}Checkbox`}
                    checked={this.state.checkedFacilities[item.id]}
                    onChange={() => {
                        let temp = this.state.checkedFacilities;
                        if (!temp[item.id]) {
                            temp[item.id] = true;
                        } else {
                            delete temp[item.id];
                        }
                        this.setState({
                            checkedFacilities: temp,
                        });
                    }}
                />,
            },
        ];
    }

    componentWillMount() {
        !this.props.inProgress2 && this.props.removeFacilitiesAction(null, this.props.initialValues);
        !this.props.inProgress && !this.props.inProgress2 && this.props.reset();
    }

    componentDidMount() {
        const { initialValues, callbacks, additional, savedCallbacks, savedAdditional, inProgress2 } = this.props;

        if (savedCallbacks && inProgress2 && Object.keys(savedCallbacks).length > 0) {
            this.initSubscriptions(savedCallbacks);
        } else if (callbacks && inProgress2 && Object.keys(callbacks).length > 0) {
            this.initSubscriptions(callbacks);
        } else if (initialValues.id) {
            this.initSubscriptions(initialValues);
        }
        if (savedAdditional && inProgress2 && Object.keys(savedAdditional).length > 0) {
            this.initAdditional(savedAdditional);
        } else if (additional && inProgress2 && Object.keys(additional).length > 0) {
            this.initAdditional(additional);
        } else if (initialValues.id) {
            this.initAdditional(initialValues);
        }
    }

    componentDidUpdate(prevProps) {
        const { initialValues, callbacks, saveCallbacks } = this.props;

        saveCallbacks(callbacks);

        if (!_.isEqual(initialValues, prevProps.initialValues)) {
            this.initSubscriptions(initialValues);
            this.initAdditional(initialValues);
        }
    }

    initSubscriptions = (initialValues) => {
        subscriptions.forEach(({name}) => {
            if (initialValues.hasOwnProperty(name) && initialValues[name].length > 0) {
                this.enableSubscription(name);
            }
        });
    }

    initAdditional = (initialValues) => {
        additional.forEach(({name}) => {
            if (initialValues.hasOwnProperty(name) && initialValues[name]) {
                const isAdditionalEnabled = this.state[name];

                if (isAdditionalEnabled) {
                    this.props.change(name, '');
                }

                this.props.initialValues[name] = !isAdditionalEnabled;

                this.props.saveAdditional({'assetApi': this.props.initialValues['assetApi'], 'forcedLogIn': this.props.initialValues['forcedLogIn']});

                this.setState({
                    [name]: !isAdditionalEnabled,
                });
            }
        });
    }

    enableSubscriptions = () => {
        if (this.props.subEnabled) {
            subscriptions.forEach(({name}) => {
                this.setState({
                    [name]: false,
                });
            });
        }
    }

    enableAdditional = (name) => {
        const isAdditionalEnabled = this.state[name];

        if (isAdditionalEnabled) {
            this.props.change(name, '');
        }

        this.props.initialValues[name + '-active'] = true;

        this.props.initialValues[name] = !isAdditionalEnabled;

        this.props.saveAdditional({'assetApi': this.props.initialValues['assetApi'], 'forcedLogIn': this.props.initialValues['forcedLogIn']});

        this.setState({
            [name]: !isAdditionalEnabled,
        });
    }

    enableSubscription = (name) => {
        const isSubscriptionEnabled = this.state[name];

        if (isSubscriptionEnabled) {
            this.props.change(name, '');
        }

        this.setState({
            [name]: !isSubscriptionEnabled,
        });
    }

    handleSelect = (activeKey) => {
        this.setState({ activeKey })
    }

    handleSelect2 = (activeKey2) => {
        this.setState({ activeKey2 })
    }

    getSubscriptionLayout = ({ name, placeholder, label, alwaysEnable, fieldPlaceholder }, key) => <div
        className={`subscription${name === 'facilitiesSubscribedFor' ? ' facilities' : ''}`}
        key={key}
    >
        {!alwaysEnable && <CheckboxComponent
            name={`${name}Checkbox`}
            placeholder={placeholder}
            checked={this.state[name]}
            onChange={() => {
                this.enableSubscription(name);
            }}
        />}
        {this.state[name] && <FieldGroupComponent
            name={name}
            type="text"
            label={label}
            required
            placeholder={fieldPlaceholder}
        />}
    </div>

    prevPage = () => {
        this.props.prevPage();
    }

    handleSearch = (e) => {
        this.setState({
            searchVal: e.target.value,
        });
    }

    handleRemove = () => {
        this.props.removeFacilitiesAction(Object.keys(this.state.checkedFacilities).join(','), this.props.initialValues);
        this.setState({
            checkedFacilities: [],
        });
    }

    changeShow = (e) => {
        let option = e.target.className.split('-');
        this.setState({
            show: !this.state.show,
            filter: option[1] === 'option' ? option[0] : this.state.filter,
        });
    }

    handleChange = (e) => {
        if (e === '') {
            this.setState({
                value: '',
            });
        } else {
            this.setState({
                value: e.target.value,
            });
        }
    }

    render() {
        const {
            activeKey,
            activeKey2,
            show,
            filter,
            value,
        } = this.state;
        let {
            handleSubmit,
            initialValues,
            incorrectIds,
            addIncorrectIds,
            action,
            savedCallbacks,
            savedAdditional,
            updateSubEnabled,
        } = this.props;
        let {
            facilitiesSubscribedFor,
            facilitiesSubscriptionPending,
            facilitiesSubscriptionRejected,
            facilitiesAdded,
        } = initialValues;

        savedCallbacks && Object.keys(savedCallbacks).forEach((callback) => {
            initialValues[callback] = savedCallbacks[callback];
        });

        savedAdditional && Object.keys(savedAdditional).forEach((additional) => {
            initialValues[additional] = savedAdditional[additional];
        });

        let incorrectNum = 0;
        let newIncorrect = '';
        incorrectIds && incorrectIds.split(',').forEach(id => {
            if (facilitiesAdded && facilitiesAdded.split(',').includes(id.trim())) {
                incorrectNum++;
                newIncorrect.length > 0 && (newIncorrect += ',');
                newIncorrect += id;
            }
        });

        if (incorrectIds && (incorrectIds.trim() !== newIncorrect.trim())) {
            newIncorrect !== '' && (newIncorrect = newIncorrect.slice(0, -1));
            addIncorrectIds(newIncorrect);
        }

        let facilities = [];

        if (!facilitiesSubscribedFor && !facilitiesSubscriptionPending && !facilitiesSubscriptionRejected && !facilitiesAdded) {
            facilities = null;
        } else {
            let subscribedRevised = facilitiesSubscribedFor && action !== LICENSE_ACTIONS.move ? facilitiesSubscribedFor.split('-')[0] : '';
            subscribedRevised && (filter === 'all' || filter === 'approved') && subscribedRevised.split(',').forEach(item => {
                item.includes(this.state.searchVal) && facilities.push({id: parseInt(item, 10), ordering: 3, status: 'Approved'});
            });

            let pendingRevised = facilitiesSubscriptionPending && action !== LICENSE_ACTIONS.move ? facilitiesSubscriptionPending.split('-')[0] : '';
            pendingRevised += (facilitiesAdded !== '' && facilitiesAdded !== undefined ? ((pendingRevised.length > 0 ? ',' : '') + facilitiesAdded) : '');
            pendingRevised && (filter === 'all' || filter === 'pending') && pendingRevised.split(',').forEach(item => {
                if (!incorrectIds || !incorrectIds.includes(item)) {
                    item.includes(this.state.searchVal) && facilities.push({id: parseInt(item, 10), ordering: 2, status: 'Pending'});
                }
            });

            let rejectedRevised = facilitiesSubscriptionRejected && action !== LICENSE_ACTIONS.move ? facilitiesSubscriptionRejected.split('-')[0] : '';
            rejectedRevised && (filter === 'all' || filter === 'unauthorized') && rejectedRevised.split(',').forEach(item => {
                item.includes(this.state.searchVal) && facilities.push({id: parseInt(item, 10), ordering: 1, status: 'Unauthorized'});
            });

            incorrectIds && (filter === 'all' || filter === 'incorrect') && incorrectIds.split(',').forEach(item => {
                item.trim().includes(this.state.searchVal) && facilitiesAdded && facilitiesAdded.includes(item.trim()) && facilities.push({id: parseInt(item.trim(), 10), ordering: 0, status: 'Incorrect ID'});
            });

            if (!(subscribedRevised || pendingRevised || rejectedRevised)) {
                facilities = null;
            }
        }

        updateSubEnabled(facilities && facilities.length > 0);

        return <div>
            <div className="back-option" onClick={this.prevPage}>
                <span> Back </span>
            </div>
            <div className='facility-info'>
                <span>Add a Facility ID to request facility-level access to callback event
                     subscriptions and additional functionality.</span>
            </div>
            <div className='facility-note'>
                <b>Important Note:</b> Facility IDs are unique to Development and Production licenses and cannot transfer between environments.
            </div>
            <AddFacilitiesContainer license={initialValues} handleChange={this.handleChange} value={value} isMove={action === LICENSE_ACTIONS.move} />
            <Form onSubmit={handleSubmit}>
                {facilities && <div>
                    <PanelGroup accordion id="callback-panel" activeKey={activeKey} onSelect={this.handleSelect}>
                        <div className='section-header'>Select Callback Event(s) <span className='req'>*</span></div>
                        <div className='callback-note'>At least one callback event must be selected.</div>
                        <PanelComponent
                            title="Personal"
                            eventKey={1}
                            activeKey={activeKey}
                        >
                            <div className="subscriptions">
                                {PERSONAL_SUBSCRIPTIONS.map(this.getSubscriptionLayout)}
                            </div>
                        </PanelComponent>
                        <PanelComponent
                            title="Cardio"
                            eventKey={2}
                            activeKey={activeKey}
                        >
                            <div className="subscriptions">
                                {CARDIO_SUBSCRIPTIONS.map(this.getSubscriptionLayout)}
                            </div>
                        </PanelComponent>
                        <PanelComponent
                            title="Strength"
                            eventKey={3}
                            activeKey={activeKey}
                        >
                            <div className="subscriptions">
                                {STRENGTH_SUBSCRIPTIONS.map(this.getSubscriptionLayout)}
                            </div>
                        </PanelComponent>
                        <PanelComponent
                            title="Asset"
                            eventKey={4}
                            activeKey={activeKey}
                        >
                            <div className="subscriptions">
                                {ASSET_SUBSCRIPTIONS.map(this.getSubscriptionLayout)}
                            </div>
                        </PanelComponent>
                    </PanelGroup>
                    <PanelGroup accordion id="callback-panel" activeKey={activeKey2} onSelect={this.handleSelect2}>
                        <div className='section-header'>Additional Functionality <span className='req'>*</span></div>
                        <div className='callback-note'>Developers can request access to a growing list of
                         facility-level console API integration.</div>
                        <PanelComponent
                            title="Asset and Facility APIs"
                            eventKey={1}
                            activeKey={activeKey2}
                        >
                            <div className="subscriptions">
                                <div className='subscription'>
                                    <div className='description'>Enables access to the Asset Management APIs for entered facilities.</div>
                                    <CheckboxComponent
                                        name='assetApiCheckbox'
                                        placeholder={'Request Access to Asset & Facility APIs'}
                                        checked={this.state['assetApi']}
                                        onChange={() => {
                                            this.enableAdditional('assetApi');
                                        }}
                                    />
                                </div>
                            </div>
                        </PanelComponent>
                        <PanelComponent
                            title="Forced Log In"
                            eventKey={2}
                            activeKey={activeKey2}
                        >
                            <div className="subscriptions">
                                <div className='subscription'>
                                    <div className='description'>Enables log in requirement to access workout options
                                     for compatible consoles of selected facility.
                                        <TooltipComponent
                                            overlayContent={<span>
                                                <div className='tooltip-header'><b>Compatible Consoles</b></div>
                                                <ol>
                                                    <li>Discover SE3</li>
                                                    <li>Discover SE3HD</li>
                                                    <li>Discover ST</li>
                                                    <li>Cybex 70T</li>
                                                </ol>
                                                <LinkComponent url="../api/web/compatibility" title="Learn More" className="learn-more" isExternalLink />
                                            </span>}
                                            className={'force-login-tooltip'}
                                            placement={'bottom'}
                                            keepOpen
                                            allowHover
                                            show={this.state.showForceTooltip}
                                            setShow={(val) => {
                                                this.setState({ showForceTooltip: val });
                                            }}
                                            children={<span className='info-icon-force' />}
                                        />
                                    </div>
                                    <CheckboxComponent
                                        name='forcedLogInCheckbox'
                                        placeholder={'Request Access to Forced Log In'}
                                        checked={this.state['forcedLogIn']}
                                        onChange={() => {
                                            this.enableAdditional('forcedLogIn');
                                        }}
                                    />
                                </div>
                            </div>
                        </PanelComponent>
                    </PanelGroup>
                    <hr className='license-form-divider' />
                    <div className='status-box'>
                        <div className='section-header'>Approval Status Per Facility ID</div>
                        <TooltipComponent
                            overlayContent={<div className={'tooltip-content'}>
                                <div className={'all-option' + (filter === 'all' ? ' selected' : '')} onClick={this.changeShow}>View All</div>
                                <hr />
                                <div className={'incorrect-option' + (filter === 'incorrect' ? ' selected' : '')} onClick={this.changeShow}><span className={'error-icon'} /> Incorrect ID</div>
                                <hr />
                                <div className={'unauthorized-option' + (filter === 'unauthorized' ? ' selected' : '')} onClick={this.changeShow}><span className={'error-icon'} /> Unauthorized</div>
                                <hr />
                                <div className={'pending-option' + (filter === 'pending' ? ' selected' : '')} onClick={this.changeShow}><span className={'pending-icon'} /> Pending</div>
                                <hr />
                                <div className={'approved-option' + (filter === 'approved' ? ' selected' : '')} onClick={this.changeShow}><span className={'approved-icon'} /> Approved</div>
                            </div>}
                            className={'filter-search-tooltip'}
                            placement={'bottom'}
                            keepOpen
                            show={show}
                            setShow={(val) => this.setState({ show: val })}
                            children={
                                <span className='filter-button' onClick={this.changeShow} />
                            }
                        />
                        <FieldGroupComponent
                            name="search"
                            type="search"
                            placeholder="Search by Facility ID"
                            onChange={this.handleSearch}
                        />
                        {incorrectNum !== undefined && incorrectNum > 0 && <div className='incorrect-text'>{incorrectNum <= 1 ? (incorrectNum + ' Facility ID was added incorrectly. Please remove it to continue.') : (incorrectNum + ' Facility IDs were added incorrectly. Please remove them to continue.')}</div>}
                        {facilities && facilities.length > 0
                            ? <GridContainer
                                name="facility-ids"
                                gridProps={this.GRID_PROPS}
                                items={facilities}
                                itemsPerPage={facilities.length}
                                sortBy={['ordering', 'id']}
                            />
                            : <div>Your search did not match any Facility ID's.</div>}
                        <Button onClick={this.handleRemove} disabled={Object.keys(this.state.checkedFacilities).length < 1} className="btn btn-default">Remove Selected{Object.keys(this.state.checkedFacilities).length > 0 ? ' (' + Object.keys(this.state.checkedFacilities).length + ')' : ''}</Button>
                    </div>
                </div>}
            </Form>
        </div>;
    }
}

LicenseSubscriptionFormComponent.defaultProps = {
    description: '',
};

LicenseSubscriptionFormComponent.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    subEnabled: PropTypes.bool,
    initialValues: PropTypes.object.isRequired,
    change: PropTypes.func,
    prevPage: PropTypes.func,
    reset: PropTypes.func,
    removeFacilitiesAction: PropTypes.func.isRequired,
    incorrectIds: PropTypes.string,
    addIncorrectIds: PropTypes.func,
    inProgress: PropTypes.bool,
    inProgress2: PropTypes.bool,
    action: PropTypes.string,
    callbacks: PropTypes.object,
    additional: PropTypes.object,
    savedCallbacks: PropTypes.object,
    saveCallbacks: PropTypes.func,
    savedAdditional: PropTypes.object,
    saveAdditional: PropTypes.func,
    updateSubEnabled: PropTypes.func,
};

export default LicenseSubscriptionFormComponent;



// WEBPACK FOOTER //
// ./src/components/profile/License/LicenseSubscriptionFormComponent.js